import React, { useContext } from 'react';
import { GoAButton, GoACallout, GoASpacer } from '@abgov/react-components';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

interface LoginProps {}

const LoginComponent = ({}: LoginProps) => {
  const { signinRedirect } = useAuth();

  let navigate = useNavigate();

  const handleLoginToAlbertaIdClick = () => {
    signinRedirect();
  };

  const handleGuestTokenClick = () => {
    let path = '/otp/login';
    navigate(path);
  };

  return (
    <main>
      {/* <GoASpacer vSpacing={"2xl"} /> */}
      <h1>How would you like to log in to Report My Collision?</h1>
      {/* <GoASpacer vSpacing={"l"} /> */}
      <GoAButton type="secondary" onClick={() => handleLoginToAlbertaIdClick()}>
        Verified account login
      </GoAButton>
      <GoASpacer vSpacing={'m'} />
      <GoAButton type="secondary" onClick={handleGuestTokenClick}>
        Guest Collision ID
      </GoAButton>
      <GoASpacer vSpacing={'2xl'} />
      <GoACallout heading="Logging in with your saved guest collision ID">
        Messaging around emailing the save token lorem ipsum dolor sit amet,
        consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
        et dolore magna aliqua.
      </GoACallout>
      <GoASpacer vSpacing={'3xl'} />
    </main>
  );
};

export default LoginComponent;
